import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { parseCollabSpace } from './parseCollabSpace';
import { FluidOwaSource, isFluidEnabledForSource } from 'owa-fluid-validations';

export function isCollabAllowedInEvent(
    event: CalendarEvent,
    fluidOwaSource: FluidOwaSource
): boolean {
    if (!isFluidEnabledForSource(fluidOwaSource)) {
        return false;
    }

    const collabSpace = parseCollabSpace(event.CollabSpace);

    return collabSpace?.collabAllowed;
}
